exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".exportText[data-v-3f428bfe]{margin:15px 0;color:#2a2e31;font-size:24px;font-weight:700;text-align:center}.btnWrapper[data-v-3f428bfe]{width:240px;margin:0 auto}.btnWrapper .btn[data-v-3f428bfe]{padding-top:10px;padding-bottom:10px;border:none}", ""]);

// exports
